import * as styled from '../styles';
import { maskPhone } from '../helpers';

type Props = {
  countryCode: string;
  localNumber: string;
  otpCode: string;
  isLoading: boolean;
  error: string | null;
  onOtpCodeChange: (value: string) => void;
  onVerifyOtp: () => void;
  onBackToPhone: () => void;
};

export const OtpStep = ({
  countryCode,
  localNumber,
  otpCode,
  isLoading,
  error,
  onOtpCodeChange,
  onVerifyOtp,
  onBackToPhone,
}: Props) => (
  <>
    <styled.Heading>Enter code</styled.Heading>
    <styled.Subheading>
      We sent a 6-digit code to {maskPhone(countryCode, localNumber)}. Enter it
      below to continue.
    </styled.Subheading>

    <styled.Card>
      <styled.Label>Verification code</styled.Label>
      <styled.OtpInput
        type="text"
        inputMode="numeric"
        pattern="[0-9]*"
        placeholder="······"
        maxLength={6}
        value={otpCode}
        onChange={(event) => onOtpCodeChange(event.target.value.replace(/\D/g, ''))}
        disabled={isLoading}
        onKeyDown={(event) => event.key === 'Enter' && onVerifyOtp()}
        autoFocus
      />

      {error && <styled.ErrorText>{error}</styled.ErrorText>}

      <styled.Button
        disabled={isLoading || otpCode.length !== 6}
        onClick={onVerifyOtp}
      >
        {isLoading ? 'Verifying...' : 'Verify'}
      </styled.Button>

      <styled.BackButton onClick={onBackToPhone}>
        ← Wrong number? Go back
      </styled.BackButton>
    </styled.Card>
  </>
);
